import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface WalletState {
	balance: number
	bonus: number
}

const initialState: WalletState = {
	balance: 0,
	bonus: 0
}

export const walletSlice = createSlice({
	name: 'wallet',
	initialState,
	reducers: {
		setWalletBalance: (state, action: PayloadAction<number>) => {
			state.balance = action.payload
		},
		setWalletBonus: (state, action: PayloadAction<number>) => {
			state.bonus = action.payload
		}
	}
})

export default walletSlice.reducer